'use strict';

class BranchSelector {

    constructor() {
        this.showButtonEl = document.querySelector('.header__toolbar-item--branch');

        this.sideNavContainerEl = document.querySelector('.branch__container');

        if (!this.sideNavContainerEl) return;

        this.sideNavEl = document.querySelector('.branch__selector');

        this.showSelector = this.showSelector.bind(this);
        this.hideSelector = this.hideSelector.bind(this);

        this.previousActiveElement = undefined;

        this.addEventListeners();

    }

    addEventListeners() {

        if (this.showButtonEl) {
            this.showButtonEl.addEventListener('click', this.showSelector);
        }

        document.addEventListener('scroll', this.hideSelector);

        this.sideNavContainerEl.addEventListener('click', (e) => {
            if (e.target.classList.contains('branch__container'))
                this.hideSelector();
        });
    }

    blockClicks(evt) {
        evt.stopPropagation();
    }

    showSelector(e) {
        this.previousActiveElement = e.target;
    }

    hideSelector() {
        if (this.previousActiveElement) this.previousActiveElement.focus();
    }
}

document.addEventListener("DOMContentLoaded", function () {
    new BranchSelector();
});